import axios from 'axios'
import Cookies from 'js-cookie';
import config from './config';
const loginData = (!Cookies.get('OnchainMatrix')) ? [] : JSON.parse(Cookies.get('OnchainMatrix'));

const serverPath = (config.seedRoundApiUrl || "").replace(/\/+$/, "");
export const request = (path, data, method) => {
    const endpoint = String(path || "").replace(/^\/+/, "");
    console.log(`${serverPath}/${endpoint}`)
    try {
        var options = {
            method: method,
            url: `${serverPath}/${endpoint}`,
            headers: {
                'Content-Type': 'application/json'
            },
            dataType: 'json'
        };
        if (loginData) {
            options.headers['Authorization'] = loginData
        }
        if (method === 'GET') {
            options['params'] = data
        } else {
            options['data'] = data
        }
        let res = axios(options)
        res.then(res1 => { })
        return res
    } catch (error) {
        // return res.status(500).send({success: false})
        console.log('errr', error)
    }

}


export const seedRoundPostRequest = async (path, data) => await request(path, data, 'POST')
export const seedRoundGetRequest = async (path, data) => await request(path, data, 'GET')
